import { createContext as e, useContext as n } from "react";
const o = {
  isLoading: !0,
  isAuthenticated: !1
}, i = {
  ...o
}, s = e(
  i
), u = () => {
  const t = n(s);
  if (t === void 0)
    throw new Error("Oooops! useKindeAuth must be used within a KindeProvider");
  return t;
};
export {
  s as K,
  u
};
